module.exports = __webpack_public_path__ + "static/media/doctorprofile.9c719fd9.jpg";